module.exports = __webpack_public_path__ + "static/029-a7355512bb0f08859f589d2017c78b07.png";